import React, { ReactElement } from 'react';
import { CookieBanner as Banner } from 'b2b-components/theme/components/CookieBanner';
import { ComponentType, Props } from './';

export const CookieBanner: ComponentType = ({
  onAccept,
  isVisible,
  text,
}: Props): ReactElement | null => (
  <Banner
    isVisible={isVisible}
    onAccept={onAccept}
    text={text}
  />
);
